import resultsTransform from 'src/client/transformers/resultsTransform';

export default ({ url, Model }: { url: string; Model: any }) => ({
  url,
  method: 'GET',
  transformResponse: [(data: string) => resultsTransform(data, Model)]
});
